import { CelebrationIcon } from '@/atoms/Icons/CelebrationIcon'
import { Image } from '@/atoms/Image'
import { useTranslate } from '@/utils/translate/translate-client'
import { DavidButton } from './DavidButton'

const imgInspireGen = '/v1760914561/theatrical/david/dirt-texture-on-white-01'

function Counter() {
  const { t } = useTranslate('pif')
  return (
    <div
      className="relative w-full shrink-0 rounded-[24px] md:h-[480px] md:min-h-px md:min-w-px md:grow md:basis-0"
      data-name="counter"
    >
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-[24px]">
        <div className="absolute inset-0 rounded-[24px] bg-[#f9b74b]" />
        <Image
          alt=""
          className="rounded-[24px] object-cover opacity-80"
          src="/v1760542675/theatrical/david/ticket-pif-icon-collage"
          fill
          sizes="(max-width: 768px) 100vw, 50vw"
        />
      </div>
      <div className="flex size-full flex-col items-center justify-center">
        <div className="relative box-border flex w-full flex-col content-stretch items-center justify-center gap-[32px] px-[64px] py-16 md:h-[480px] md:p-[64px]">
          <div className="relative flex w-full shrink-0 flex-col content-stretch items-center gap-[8px]">
            <div className="relative flex shrink-0 flex-col content-stretch items-center text-nowrap text-center not-italic leading-[0] text-[#411e09]">
              <div className="font-whitney-medium relative flex shrink-0 flex-col justify-center text-[16px]">
                <p className="whitespace-pre text-nowrap leading-[20px]">
                  {t('kidsReachedToDate', 'Kids Reached to Date')}
                </p>
              </div>
              <div className="font-angel-royal relative flex shrink-0 flex-col justify-center text-[80px] md:text-[96px] md:tracking-[0.5px]">
                <p className="whitespace-pre text-nowrap leading-[64px] md:leading-[80px]">239,029</p>
              </div>
            </div>
            <div className="relative box-border flex h-[28px] shrink-0 content-stretch items-center justify-center gap-[4px] rounded-[100px] bg-[#fff4eb] px-[12px] py-[4px]">
              <div className="relative size-[14px] shrink-0">
                <CelebrationIcon className="block size-full" size={14} color="core-warning-800" />
              </div>
              <div className="font-whitney-medium relative flex shrink-0 flex-col justify-center overflow-hidden text-ellipsis text-nowrap text-center text-[14px] not-italic leading-[0] text-[#763401]">
                <p className="overflow-hidden text-ellipsis whitespace-pre leading-[18px]">
                  {t('davidGiftedByExample', 'Diane from New York gifted 2 tickets')}
                </p>
              </div>
            </div>
          </div>
          <DavidButton variant="red" href="#" openPifOverlay>
            {t('helpKidsGoFree', 'Help Kids Go Free')}
          </DavidButton>
        </div>
      </div>
    </div>
  )
}

export function EndCtaSection() {
  const { t } = useTranslate('pif')

  return (
    <section className="relative w-full px-[16px] py-[96px] md:px-[64px] md:py-[160px]" data-name="end-cta">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[#faf0e7]" />
        <Image
          alt=""
          className="object-cover opacity-[0.55] mix-blend-color-burn"
          src={imgInspireGen}
          fill
          sizes="100vw"
          loading="lazy"
        />
      </div>
      <div
        className="relative mx-auto flex w-full max-w-[1440px] shrink-0 flex-col content-stretch items-start gap-[40px] md:flex-row md:gap-0"
        data-name="container-50-flip"
      >
        <Counter />
        <div className="relative w-full shrink-0 md:min-h-px md:min-w-px md:grow md:basis-0 md:self-stretch">
          <div className="flex size-full flex-col justify-center">
            <div className="relative box-border flex size-full flex-col content-stretch items-start justify-center gap-[32px] p-0 md:gap-[40px] md:py-[64px] md:pl-[64px]">
              <div className="relative flex w-full shrink-0 flex-col content-stretch items-start gap-[12px]">
                <p className="font-angel-royal relative w-full shrink-0 text-[40px] lowercase not-italic leading-[40px] text-[#141447] md:text-[64px] md:leading-[64px]">
                  {t('davidThousandsJoinedTitle', 'Thousands Have Already Paid It Forward – Join Them')}
                </p>
                <p className="font-whitney-medium md:font-whitney-medium relative w-full shrink-0 text-[16px] not-italic leading-[24px] text-[#141447] md:text-[18px] md:leading-[28px]">
                  {t(
                    'davidThousandsJoinedDescription',
                    'Every ticket builds momentum. Every family reached brings us closer to inspiring a generation.',
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
